import React from 'react'
import styled from 'styled-components/macro'

import Label from '../Typography/Label'

const Component = styled.div`
  display: flex;
  align-items: center;
`

const Box = styled.div`
  flex-shrink: 0;
  position: relative;
  border-radius: 2px;
  width: 28px;
  height: 28px;
  background: ${(props) =>
    props.checked
      ? props.theme.colors.brand.primary
      : props.theme.colors.grey.white};
  margin-right: 8px;
`

const CheckIcon = styled.div`
  &:after {
    animation-duration: 400ms;
    animation-timing-function: ease;
    animation-name: checkmark;
    transform: scaleX(-1) rotate(135deg);
  }

  &:after {
    opacity: 1;
    height: 15px;
    width: 8px;
    transform-origin: left top;
    border-right: 2px solid ${(props) => props.theme.colors.grey.white};
    border-top: 2px solid ${(props) => props.theme.colors.grey.white};
    content: '';
    left: 5px;
    top: 14px;
    position: absolute;
  }

  @keyframes checkmark {
    0% {
      height: 0;
      width: 0;
      opacity: 1;
    }
    20% {
      height: 0;
      width: 8px;
      opacity: 1;
    }
    40% {
      height: 15px;
      width: 8px;
      opacity: 1;
    }
    100% {
      height: 15px;
      width: 8px;
      opacity: 1;
    }
  }
`

const Check = ({ checked, onClick, text }) => (
  <Component onClick={onClick}>
    <Box checked={checked}>{checked && <CheckIcon />}</Box>
    <Label>{text}</Label>
  </Component>
)

export default Check
